var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HttpClient } from '@angular/common/http';
import { Router } from '@angular/router';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { MatDialogConfig } from '@angular/material';
import { PaginatorIntlService } from '@services/Paginator-intl.service';
// AoT requires an exported function for factories
export function HttpLoaderFactory(http) {
    return new TranslateHttpLoader(http);
}
var ɵ0 = {
    parse: {
        dateInput: ['l', 'LL']
    },
    display: {
        dateInput: 'L',
        monthYearLabel: 'MMM YYYY',
        dateA11yLabel: 'LL',
        monthYearA11yLabel: 'MMMM YYYY'
    }
}, ɵ1 = { useUtc: true }, ɵ2 = __assign({}, new MatDialogConfig(), { width: 500 }), ɵ3 = function (translate) {
    var service = new PaginatorIntlService();
    service.injectTranslateService(translate);
    return service;
};
var AppModule = /** @class */ (function () {
    function AppModule(router) {
        this.router = router;
        // for debugging routing issues
        // router.events.subscribe(console.log);
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0, ɵ1, ɵ2, ɵ3 };
